export default __webpack_public_path__ + "static/media/background.915292f1.webp";